import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  color: #fff;
  background-color: #242943;

  .inner {
    padding: 2em 0 1em 0;
    margin: 0 auto;
    width: calc(100% - 6em);
  }

  header {
    width: max-content;
  }

  h2 {
    font-family: "Comfortaa", Helvetica, sans-serif;
    font-size: 1.1em;

        @media (min-width: 768px) {
      font-size: 1.75em;
    }

    &:after {
      content: '';
      background-color: #ffffff;
      display: block;
      height: 2px;
      margin: 0.325em 0 0.5em 0;
      width: 100%;
      width: calc(100% + 0.5em);
    }
  }
`;